module.exports = __webpack_public_path__ + "img/manoLF.6e74b2b9.png";